const STORAGE_KEY = 'WECHAT:OPENID';

export default {
    get() {
        return localStorage.getItem(STORAGE_KEY);
    },
    set(openid) {
        localStorage.setItem(STORAGE_KEY, openid);
    },
    remove() {
        localStorage.removeItem(STORAGE_KEY);
    },
};



// WEBPACK FOOTER //
// ./src/store/wechat/storage.js